const { href } = window.location
export const isProd = !href.includes('localhost') && !href.includes('192.168.0')